import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../components/auth/auth.service';
import { UtilityService } from '../../shared/services/Utility.service';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

interface User {
  newPassword: string;
  confirmPassword: string;
}

@Component({
  selector: 'resetpassword',
  template: require('./resetpassword.html'),
})
export class ResetPasswordComponent implements OnInit {
  user: User = {
    newPassword: '',
    confirmPassword: ''
  };

  submitted = false;
  AuthService;
  strength: number = 0;
  strengthText: string = 'Weak';
  strengthColor: string = 'red';
  isTypingPassword: boolean = false;
  message = '';
  selectedUser: any;

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    backdrop: `rgba(30, 30, 37, 0.4)`
  });
  errors: any;

  toastWarningMsg(options) {
    if (typeof (options) == "object") {
      this.toast({
        type: 'warning',
        showConfirmButton: options.confirm_btn,
        timer: options.timer,
        title: options.msg
      });
    } else {
      this.toast({
        type: 'warning',
        title: options
      });
    }
  };

  f_check_string(p_value) {
    if (p_value == undefined || p_value === '' || p_value === null || p_value !== p_value) {
      return "";
    } else {
      return p_value;
    }
  }
  f_check_num(p_value) {
    var Val = Number(p_value);
    if (Val) {
      return Val;
    }
    return 0;
  }

  static parameters = [HttpClient, HotkeysService, Router, AuthService, UtilityService];
  constructor(private http: HttpClient, private hotkeysService: HotkeysService, private router: Router, _AuthService_: AuthService, public utilityService: UtilityService) {
    this.http = http;
    this.hotkeysService = hotkeysService;
    this.AuthService = _AuthService_;
    this.utilityService = utilityService;
  }

  ngOnInit(): void {
    const email = this.utilityService.emailForForgotPassword;
    if (email) {
      this.selectedUser = email;
    }

  }

  passwordStrength(value: string) {
    this.isTypingPassword = value.length > 0;
    this.strength = this.utilityService.calculateStrength(this.user.newPassword);

    if (this.strength < 50) {
      this.strengthText = 'Weak';
      this.strengthColor = 'red';
    } else if (this.strength < 100) {
      this.strengthText = 'Average';
      this.strengthColor = 'orange';
    } else {
      this.strengthText = 'Strong';
      this.strengthColor = 'green';
    }
  };

  movefocus(id) {
    if (id == 1) {
      $('#confirmPassword').focus().select();
    } else if (id == 2) {
      // this.isTypingPassword = true;
      $('#save1').focus().select();
    }
  }

  revealPass(event, inputID, revealID) {
    // console.log('🚀 ~ event:', event)
    const password = document.querySelector('#' + inputID);
    const toggle = document.querySelector('#' + revealID);
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    toggle.classList.toggle('fa-eye-slash');
  };

  resetPassword(form) {
    this.message = '';

    let status = this.passwordValidate();
    if (!status) {
      setTimeout(() => { $("input[name=newPassword]").focus(); }, 100);
      return false;
    }

    if (this.f_check_string(this.user.confirmPassword).trim() === "") {
      this.toastWarningMsg("Enter the Confirm Password");
      $("#confirmPassword").focus();
      return false;
    }

    if (this.user.newPassword !== this.user.confirmPassword) {
      this.toastWarningMsg("New password and Confirm new password do not match");
      $("#confirmPassword").focus();
      return false;
    }

    this.submitted = true;

    return this.AuthService.resetPassword(this.selectedUser, this.user.newPassword, (res) => { return res })
      .then((response) => {
        console.log("Reset password API response:", response);

        if (response.flag === true) {
          this.message = 'Password successfully reset';
          this.toastWarningMsg("Password successfully reset");
          setTimeout(() => {
            this.router.navigateByUrl('/login');
          }, 800);
        } else {
          this.message = '';
          this.toastWarningMsg("Password reset failed, try again.");
        }
      })
      .catch(() => {
        this.errors.other = 'Password reset error';
        this.message = 'Error during password reset';
      });
  }


  passwordValidate() {
    this.isTypingPassword = true;
    if (!this.user.newPassword) {
      return;
    }
    if (this.user.newPassword.length < 8) {
      // this.toastWarningMsg('Password should be minimum of 8 characters !');
      setTimeout(() => {
        $('input[name=newPassword]').focus();
      }, 100);
      return false;
    }
    var pass = this.user.newPassword;
    var specialCharPattern = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    var uppercasePattern = /[A-Z]/;
    var numericPattern = /[0-9]/;

    if (this.f_check_string(pass.search(specialCharPattern) == -1)) {
      // this.toastWarningMsg('Password must have at least one special character!');
      setTimeout(() => {
        $('input[name=newPassword]').focus();
      }, 100);
      return false;
    }

    if (this.f_check_string(pass.search(uppercasePattern) == -1)) {
      // this.toastWarningMsg('Password must have at least one uppercase letter!');
      setTimeout(() => {
        $('input[name=newPassword]').focus();
      }, 100);
      return false;
    }

    if (this.f_check_string(pass.search(numericPattern) == -1)) {
      // this.toastWarningMsg('Password must have at least one numeric digit!');
      setTimeout(() => {
        $('input[name=newPassword]').focus();
      }, 100);
      return false;
    }
    return true;
  };

  per: any;
  logout() {
    var per = JSON.parse(localStorage.getItem('permission'))[0];
    this.http.post('/api/users/RemoveLoggedInTime', { "UserId": per["_id"] })
      .subscribe(response => {
        return this.AuthService.logout().then(() => {
          this.router.navigateByUrl('/login');
          localStorage.clear();
        });
      });
  };
}
